import { Toaster } from "react-hot-toast";
import Layout from "./shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { API_URL, baseurl } from "../_config";
import toast from "react-hot-toast";

const UserList = () => {
    const navigate = useNavigate();
    const [userList, setUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [isFormopen, setIsFormopen] = useState(false);
    const [userId, setUserId] = useState(0);

    const [formData, setFormData] = useState({
        name: "",
        password: "1234",
        mobileNo: "",
    });

    const fetchuserList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getuserdetail}`);
            if (response.status === 200) {
                const filterData = response.data.data.filter(item => item.IsDeleted === 0);
                const sortedData = filterData.sort((a, b) => b.LoginId - a.LoginId); // descending by id
                setUserList(sortedData);
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchuserList();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = userList?.filter(item =>
                (item.Name && item.Name.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.MobileNo && item.MobileNo.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(userList);
        }
    }, [searchTerm, userList]);

    const onBookingDetailByLoginId = (row) => {
        navigate(`/booking-detail/${row?.LoginId}`);
    }

    // Handle input changes for all form fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${baseurl}${API_URL?.userregister}`, formData);

            if (response.status === 200) {
                toast.success("Save Successfully");
                setIsFormopen(false);
                fetchuserList();
                onClose();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    const onClose = () => {
        setIsFormopen(false);
        setFormData({
            name: "",
            password: "1234",
            mobileNo: "",
        });
    }

    const handleDelete = async (loginId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this News?");

        if (isConfirmed) {
            try {
                const response = await axios.post(`${baseurl}${API_URL?.deleteaccount}`, {
                    loginId: loginId
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.status === 200) {
                    toast.success("News Deleted Successfully");
                    fetchuserList();
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Name',
            selector: row => row.Name,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.EmailId}</h6>
                    <span>{row?.MobileNo}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'DOB',
            selector: row => {
                if (row.DOB) {
                    const date = new Date(row.DOB);
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '150px'
        },
        {
            name: 'Gender',
            selector: row => row.Gender || 'N/A',
            sortable: false,
            minWidth: '100px'
        },
        {
            name: 'Referral Code',
            selector: row => row.referralCode || 'N/A',
            sortable: false,
            minWidth: '120px'
        },
        {
            name: 'Referral Count',
            selector: row => row.referralCount || 0,
            sortable: false,
            minWidth: '120px'
        },
        {
            name: 'Designation',
            selector: row => row.designation || 'N/A',
            sortable: false,
            minWidth: '120px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => onBookingDetailByLoginId(row)} title='View Booking' className='edit_icon_wepper'>
                        <i className="fa fa-calendar-check"></i>
                    </span>
                    {/* <span onClick={() => handleDelete(row?.LoginId)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span> */}
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading">
                        <h4 className="mb-0">Users List</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end gap-3">
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="add_btn">
                            <button onClick={() => setIsFormopen(true)}>Add User Manual</button>
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn" onClick={onClose}>
                        <button className=""  >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add User Manual</h4>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="title">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter Name"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="title">Mobile No.</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="mobileNo"
                                    name="mobileNo"
                                    value={formData.mobileNo}
                                    onChange={handleChange}
                                    placeholder="Enter Mobile No."
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="title">EmailId</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="emailId"
                                    name="emailId"
                                    value={formData.emailId}
                                    onChange={handleChange}
                                    placeholder="Enter EmailId"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="title">Designation</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="designation"
                                    name="designation"
                                    value={formData.designation}
                                    onChange={handleChange}
                                    placeholder="Enter designation"
                                    required
                                />
                            </div>
                            {/* <div className="form-group">
                                <label htmlFor="title">Password</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Enter Password"
                                    required
                                />
                            </div> */}

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">
                                        {userId !== 0 && userId !== null ? 'Update' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default UserList;